import { Component, OnInit, EventEmitter, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { CitNews, CitNewsType } from '../../core/index.model';

import { SessionStorageService, NewsLetterService } from '../../core/index.service';

import { HttpStatus } from '../../core/enumtype';

@Component({
    selector: 'shared-dashboard-newsletters',
    templateUrl: './newsletters.component.html',
    styleUrls: ['./newsletters.component.css']
})
export class NewsLetterDashboardComponent {

    citNews: CitNews[];
    citNewsType: CitNewsType[] = [];
    showLoading: boolean = false;
    message: string;
    isError: boolean;
    isAlert: boolean;

    constructor(
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<NewsLetterDashboardComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private newsLetterService: NewsLetterService,
        private storageService: SessionStorageService
    ) { }

    ngOnInit() {
        this.getCitizenNews(this.storageService.getJurisNo());
    }

    // To display the active news
    getCitizenNews(JurisNo: number) {
        this.showLoading = true;
        this.newsLetterService
            .GetIsMainCitizenNews(JurisNo)
            .then(res => {
                this.citNews = res;
                let typeDesc = '';
                this.citNews.forEach((item, i) => {
                    if (typeDesc != item.NewsTypeDesc) {
                        typeDesc = item.NewsTypeDesc;
                        this.citNewsType.push({ NewsTypeDesc: typeDesc, citNews: this.citNews.filter(x => x.NewsTypeDesc == typeDesc) });
                    }
                });
                this.showLoading = false;
            })
            .catch(err => {
                this.showAlert(err, true);
                this.showLoading = false;
            });
    }

    // To open the attachment while clicking the link or attachment icon
    OpenAttachment(CitNewsID: string, index: number) {
        this.newsLetterService
            .GetAttachment(CitNewsID, this.storageService.getJurisNo())
            .then(res => {
                this.citNews[index].TxtAttach = res;

                if (this.citNews[index].TxtAttach) {
                    if (this.citNews[index].TxtAttach.AttachedFile) {
                        let contentType = this.citNews[index].TxtAttach.Category;
                        let byteCharacters = atob(this.citNews[index].TxtAttach.AttachedFile);

                        let byteNumbers = new Array(byteCharacters.length);

                        for (var i = 0; i < byteCharacters.length; i++)
                            byteNumbers[i] = byteCharacters.charCodeAt(i);

                        let byteArray = new Uint8Array(byteNumbers);
                        let blob = new Blob([byteArray], { type: contentType });

                        //Code for IE browser issue (Blob not working in IE : Refer https://developer.mozilla.org/en-US/docs/Web/API/Blob)
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(blob);
                            return;
                        }
                    
                        let url = window.URL.createObjectURL(blob);
                        window.open(url);
                    }
                }
            }
            )
            .catch(err => {
                this.showAlert(err, true);
                this.showLoading = false;
            });
    }

    // Show Alert

    showAlert(strMsg: string, isErr: boolean) {
        this.isAlert = true;
        this.isError = isErr;
        this.message = strMsg;
    }

    closeModal(): void {
        this.dialogRef.close();
    }
    
}





// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/dashboard/newsletters.component.ts